module.exports = __webpack_public_path__ + "media/application/images/svgs/radio-f816d224638c5c755dd255adb80d34cb.svg";